// extracted by mini-css-extract-plugin
export default {"btn-register":"Step2_btn-register__0lAbx"};